import { environment } from '@environment';
import {
  createBingPixelConfig,
  createFacebookPixelConfig,
  createGoogleAnalyticsConfig,
  createHotjarConfig,
  createLinkedInPixelConfig,
  createTiktokPixelConfig,
  createWizbiiAnalyticsConfig,
  TrackingConfig,
} from '@wizbii/tracking';

export const trackingConfig: TrackingConfig = {
  informationGroupKeys: ['technical'],
  uuidSetterDomain: environment.api.wizbiiAnalytiks,
  consentWidget: {
    version: environment.platform !== 'prod' ? 'staging' : '',
    apiDomain: environment.apiDomain,
    wizbiiApiDomain: environment.apiDomain,
    enableTermsModal: true,
    locale: environment.lang,
    productId: environment.applicationId,
    productLabel: 'WIZBII Jobs',
    defaultValue: false,
    labels: {},
    rejectAll: true,
  },
  trackers: {
    analytics_wizbii: createWizbiiAnalyticsConfig(environment.wizbiiAnalytiksUserId, environment.api.wizbiiAnalytiks),
    analytics_google: createGoogleAnalyticsConfig(environment.googleAnalyticsUserId),
    analytics_bing: createBingPixelConfig(environment.bingPixelId),
    analytics_hotjar: createHotjarConfig({
      hjid: environment.hotjar.id,
      hjsv: environment.hotjar.version,
    }),
    analytics_facebook_pixel: createFacebookPixelConfig({
      appId: environment.facebookPixel.appId,
      version: environment.facebookPixel.version,
      locale: environment.locale,
    }),
    analytics_tiktok_pixel: createTiktokPixelConfig(environment.tiktokId),
    marketing_linkedin: createLinkedInPixelConfig(environment.linkedinPartnerId),
  },
};
